import {Component, inject, input} from '@angular/core';
import {GameStore} from '../../store/game.store';
import {ButtonModule} from 'primeng/button';
import {PanelComponent} from '../panel/panel.component';
import {ResourcesService} from '../../services/resources.service';
import {PanelButtonIcon} from "../../models/panel-button-icon.model";

@Component({
    selector: 'gis-hint',
    imports: [
    ButtonModule,
    PanelComponent
],
    templateUrl: './hint.component.html',
    styleUrl: './hint.component.scss'
})
export class HintComponent {
  protected store = inject(GameStore);
  protected readonly resourcesService = inject(ResourcesService);

  readonly buttonPosition = input<'left' | 'right'>('left');

  onIsToggled() {
    if (!this.store.questionState().hasHadHint) {
      this.store.askedHint();
    }
  }

  protected readonly PanelButtonIcon = PanelButtonIcon;
}
